const CartInfo = ({items,index,setScart,scart}) => {
    console.log(setScart)
    const del = () => {
        let temp = [...scart]
        temp.splice(index, 1)
        setScart(temp)
    }
    return (
    <div className="cartitem">
        <div className="smolImgWrapper">
        <img className="smolImage" alt={items.info.nimi} src={items.info.img}></img>
        </div>
        <div className="remove" onClick={del}>X</div>
        <h2>id: {items.id}</h2>
        <h2>{items.info.nimi}</h2>
        <h2>Määrä: {items.num}</h2>
        <h2>Hinta: {items.info.hinta * items.num}€</h2>
    </div>

    )
}


const CartContent = ({Scart, setScart}) => {
    let course = Scart.map((info, id) =>
    <CartInfo key={id} index={id} items={info} setScart={setScart} scart={Scart}/>
    )
    return(
        <div className="cartitems">
        {course}
        </div>
    )
}

export { CartContent };
